import React from "react";
import {
  Grid,
  createStyles,
  makeStyles,
  Theme,
  Typography,
  Container,
  Box,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

interface IEnterprisePriceProps {}

const EnterprisePrice: React.FC<IEnterprisePriceProps> = () => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Grid container justify="center">
        <Grid item className={classes.enterpriseCard} md={3}>
          <Typography className={classes.titlePrice}>Enterprise</Typography>
          <Typography className={classes.defined}>Defined together</Typography>
          <Typography>For users that </Typography>
          <Box mt={7} mb={6}>
            <Typography>Popular plus</Typography>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconBlue} />
              </Grid>
              <Grid item>
                <Typography>Connect local databases</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconBlue} />
              </Grid>
              <Grid item>
                <Typography>On-premise</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconBlue} />
              </Grid>
              <Grid item>
                <Typography>Own elastic instance</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconBlue} />
              </Grid>
              <Grid item>
                <Typography>Employee training</Typography>
              </Grid>
            </Grid>
          </Box>
          <Grid item className={classes.enterpriseButton}>
            Demo
          </Grid>
        </Grid>
        <Grid item md={5} className={classes.containerCard}>
          <Typography className={classes.title}>
            Thank you very much for your interest!
          </Typography>
          <Typography className={classes.text}>
            faktual received your request and will get back to you soon.{" "}
          </Typography>
          <Typography className={classes.text}>
            Until then we hope you enjoy faktual for free.
          </Typography>
          <Typography className={classes.text}>Keep it up! </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: "100px",
      height: "100%",
    },
    containerCard: {
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      borderTopRightRadius: "10px",
      borderBottomRightRadius: "10px",
      padding: theme.spacing(5),
      background: "linear-gradient(180deg, #00B0F0 0%, #0095CB 100%)",
    },
    enterpriseCard: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "10px",
      borderBottomLeftRadius: "10px",
      padding: theme.spacing(2),
    },
    enterpriseButton: {
      border: `2px solid ${theme.palette.primary.main}`,
      boxSizing: "border-box",
      borderRadius: "10px",
      height: "56px",
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.primary.main,
      cursor: "pointer",
    },
    titlePrice: {
      fontSize: "20px",
      lineHeight: "23px",
    },
    title: {
      fontSize: "20px",
      lineHeight: "23px",
      marginBottom: theme.spacing(4),
      color: "#fff",
    },
    text: {
      fontSize: "15px",
      lineHeight: "18px",
      marginBottom: theme.spacing(4),
      color: "#fff",
    },
    iconWhite: {
      fontSize: "15px",
      color: "#FFF",
    },
    iconBlue: {
      fontSize: "15px",
      color: theme.palette.primary.main,
    },
    defined: {
      fontSize: "30px",
      lineHeight: "35px",
      fontWeight: "bold",
      margin: "10px 0",
    },
  })
);

export default EnterprisePrice;
